import React, { memo } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// app inputs
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

// common healpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'

function FormAttributes(props) {
    // props
    const {
        formik,

        brands,

        productAttributes,
        setSelectedProductsAttributes,
        selectedProductsAttributes,
    } = props

    // handle attribute change
    const handleAttributeChange = debounce((ev, attrId) => {
        const inpVal = ev.target.value
        if (inpVal) {
            const doExist = selectedProductsAttributes.find(item => item.attribute_id === attrId)
            if (doExist) {
                const copyArr = [...selectedProductsAttributes]
                const data = copyArr.map(item => {
                    if (item.attribute_id === 1) {
                        return {
                            ...item,
                            attribute_value: inpVal // chaning value
                        }
                    }
                    else {
                        return item
                    }
                })

                // updating selected attribute
                setSelectedProductsAttributes(data)
            } else {
                const data = {
                    attribute_id: attrId,
                    attribute_value: inpVal,
                }

                // adding data to selected attribute
                setSelectedProductsAttributes([
                    ...selectedProductsAttributes,
                    data
                ])
            }
            console.log("selectedProductsAttributes ", selectedProductsAttributes);
        }
    }, 500)

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* btns */}
                    <div className="btns mb-3">
                        <button className="st-btn st-btn-white-gray-outlined st-btn-sm d-flex align-items-center text-capitalize">
                            <span className="round-feather-icon-outlined hoverable d-inline-flex align-items-center justify-content-center me-2">
                                <FeatherIcon
                                    icon="plus"
                                    size="10"
                                    className="icon cursor-pointer" />
                            </span>
                            <span>manage attributes</span>
                        </button>
                    </div>

                    <div className="fields xs-12 col-md-10">
                        {/* form field */}
                        <AppFormikInputInline
                            // inputType={""}
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"UPC"} // label name
                            // isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"UPC"} // placeholder for the input
                            formikFieldName={"UPC"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikSelectInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Brand"} // label name
                            formikFieldName={"brandId"} // important: formik value name for the input
                        >
                            <option disabled value="">Select Brand</option>
                            {
                                (brands && brands.length) && brands.map(item => (
                                    <option key={item.manufacturer_id} value={item.manufacturer_id}>{item.manufacturer_name}</option>
                                ))
                            }
                        </AppFormikSelectInline>

                        {
                            productAttributes?.length ? productAttributes.map(item => (
                                <div key={item.attribute_id} className="st-form st-form-with-label-left d-flex flex-wrap align-items-center ">
                                    <label>{item.attribute_name}</label>
                                    <div className="media-body st-form-input-container">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={item.attribute_name}
                                            name={item.attribute_name}
                                            onChange={ev => handleAttributeChange(ev, item.attribute_id)}
                                        />
                                    </div>
                                </div>
                            )) : null
                        }

                        <div className="st-form st-form-with-label-left d-flex flex-wrap align-items-center ">
                            <label></label>
                            <div className="media-body st-form-input-container text-left">
                                <p className="st-fs-13 st-text-color2">Attributes with the empty value are not displayed in the storefront</p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(FormAttributes)
